/**
 * Route for `creative-preview`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativePreviewPage } from "../features/creative-preview/CreativePreviewPage";

export const creativePreviewRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-preview",
	component: CreativePreviewPage,
});

export default creativePreviewRoute;
